import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

export const cartModule = defineModule({
  name: "cart",
  label: "Cart",
  requires: ["core", "accounts", "configuration", "vehicles", "catalog", "vendors", "products"],
  i18n: { en },
  // Store-only for now: the storefront (Phase 6) uses `/api/v1/store/cart`. No admin or vendor screens yet.
  admin: { routes: [], nav: [] },
  vendor: { routes: [], nav: [] },
});
